import React, { useState, useEffect } from "react";
import api from "../../api/axiosConfig";

const fetchData = async (url, setData, setError, setLoading) => {
  setLoading(true);
  try {
    const response = await api.get(url);
    setData(response.data);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching data:", error);
    setError(error);
  } finally {
    setLoading(false);
  }
};
const TimesheetSettings = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timesheetSettings, setTimesheetSettings] = useState([]);
  const [logPeriodValue, setLogPeriodValue] = useState([]);
  useEffect(() => {
    if (timesheetSettings.length > 0) {
      const logPeriod = timesheetSettings.find(
        (t) => t.settings === "log_period"
      );
      setLogPeriodValue(logPeriod.value);
    }
  }, [timesheetSettings]);

  useEffect(() => {
    fetchData(
      "/api/timesheet/settings",
      setTimesheetSettings,
      setError,
      setLoading
    );
  }, []);

  const handleUpdateLogPeriod = async (newValue) => {
    if (!newValue) {
      alert("Please enter a value before updating.");
      return;
    }

    try {
      const response = await api.put("/api/timesheet/updatelogperiod", {
        value: newValue,
      });

      const data = await response.json(); // Fix: Ensure this is after the `response` declaration

      if (!response.ok) {
        throw new Error(data.error || "Failed to update log period");
      }

      alert("Log period updated successfully!");
    } catch (error) {
      console.error("Error updating log period:", error.message);
      console.log("Error updating log period. Please try again.");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div>
        <h3>Time Log Period Settings</h3>
        <div>
          <p>Allow time logs for</p>
          <input
            className="time-log-period-input"
            placeholder="Past Value"
            type="number"
            value={logPeriodValue}
            onChange={(e) => setLogPeriodValue(e.target.value)}
            onBlur={(e) => handleUpdateLogPeriod(e.target.value)}
          />
          <span>before the current day</span>
        </div>
      </div>
    </div>
  );
};

export default TimesheetSettings;
